import { render, staticRenderFns } from "./NavigationMenuPromoGroupItem.vue?vue&type=template&id=5d7ecd9d"
import script from "./NavigationMenuPromoGroupItem.vue?vue&type=script&lang=js"
export * from "./NavigationMenuPromoGroupItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenuPromoGroupItem.vue?vue&type=style&index=0&id=5d7ecd9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports